import { cn } from "@/utils/cn";
import { memo } from "react";

interface AppBottomBarItemProps {
  label: string;
  icon: React.ReactNode;
  isActive: boolean;
  onClick: () => void;
}

export const AppBottomBarItem = memo(function AppBottomBarItem({
  label,
  icon,
  isActive,
  onClick,
}: AppBottomBarItemProps) {
  return (
    <button
      type="button"
      className={cn("flex flex-1 flex-col items-center gap-2 p-2")}
      onClick={onClick}
      aria-label={label}
      aria-current={isActive ? "page" : undefined}
    >
      <span
        className={cn("h-[19px] w-[19px] rounded-full [&_path]:fill-current", {
          "text-os-brand": isActive,
          "text-black": !isActive,
        })}
      >
        {icon}
      </span>
      <span
        className={cn("text-[11px] leading-[1.1] font-medium", {
          "text-os-brand": isActive,
          "text-black": !isActive,
        })}
      >
        {label}
      </span>
    </button>
  );
});
